module.exports = __webpack_public_path__ + "img/738ebe3b.png";